import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get, isNil } from 'lodash/fp';

// components
import { Image } from '../Image/Image';
import Conditional from '../Conditional/Conditional';

// helper functions
import * as func from '../../helpers/bodyScrollStyle';

// styles
import './case-modal-video.scss';

class CaseModalVideo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playing: false,
      visual: false,
      scrollPosition: null
    };
    this.videoPlay = React.createRef();
  }

  playVideo = () => {
    this.setState(
      {
        playing: true,
        visual: true,
        scrollPosition: window.pageYOffset
      },
      () => {
        func.activate(this.state.scrollPosition);
      }
    );
    const playPromise = this.videoPlay.current.play();
    if (playPromise !== undefined) {
      playPromise
        .then(_ => {
          this.videoPlay.current.play();

        })
        .catch(error => {
          console.log('Error from play func:', error);
        });
    }
  };

  handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      this.playVideo()
    }
  }

  resetVideo = () => {
    setTimeout(() => {
      this.setState({ playing: false, visual: false });
      this.videoPlay.current.load();
      func.deactivate(this.state.scrollPosition);
    }, 200);
  };

  closeVideo = () => {
    this.setState(() => {
      return { playing: false, visual: false };
    });
    setTimeout(() => {
      this.videoPlay.current.load();
    }, 200);
    func.deactivate(this.state.scrollPosition);
  };

  closeModal = (e) => {
    if (this.state.visual === true && e.keyCode === 27) {
      this.closeVideo()
    }
  }


  render() {
    const {awardImage} = this.props;

    return (
      <div className={`case-hero-video ${this.state.visual ? 'visual' : ''} ${this.props.className}`}>
        <div className="case-modal-video">
          <Conditional show={!isNil(awardImage)}>
            <img className="case-modal-video-award-image" src={get(['file','url'], awardImage)} alt=""/>
          </Conditional>
          <div
            className={` modal-video ${this.state.visual ? 'visual' : ''}`}
            ref="modalVideo"
          >
            <div className="modal-video-body">
              <div
                className={`case-modal-overlay ${this.state.visual ? 'visual' : ''}`}
                onClick={this.closeVideo}
                onKeyDown={this.closeModal}
                aria-hidden={true}
              />
              <div
                className="modal-video-inner"
                role='dialog'
              >
                <div className="modal-video-movie-wrap">
                  <button
                    aria-label='close'
                    onClick={this.closeVideo} 
                  />

                  <video //eslint-disable-line
                    onEnded={this.resetVideo}
                    ref={this.videoPlay}
                    data-video-source={this.props.video}
                    preload="none"
                    controls
                    controlsList="nodownload nofullscreen noremoteplayback"
                  >
                    <source src={this.props.video} type="video/mp4" />
                    Your browser can't play this video.
                  </video>
                </div>
              </div>
            </div>
          </div>

          <div className="case-modal-video__image-container">
            <Image
              className="case-modal-video__overlay-image"
              fluid={this.props.backgroundImage}
            />
            {!this.state.playing ? (
              <div className="case-modal-video__overlay">
                <div className="case-modal-video__overlay-content">
                  {this.props.title && (
                    <h1 className="case-modal-video__overlay-title">
                      {this.props.title}
                    </h1>
                  )}
                  {this.props.slogan && (
                    <p className="case-modal-video__overlay-subtitle fade-in">
                      {this.props.slogan}
                    </p>
                  )}

                  {this.props.video && (
                    <div
                      role='button'
                      tabIndex={0}
                      aria-label='Play'
                      className="case-modal-video__play-container fade-in"
                      onClick={this.playVideo}
                      onKeyDown={this.handleKeyDown}
                    >
                      <span className="first-letter">P</span>
                      <span className="second-letter">L</span>
                      <span className="case-modal-video__play" />
                      <span className="fourth-letter">A</span>
                      <span className="fifth-letter">Y</span>
                    </div>
                  )}
                </div>
              </div>
            ) : (
                <div //eslint-disable-line
                  className="case-modal-video__pause-overlay"
                  onClick={this.closeVideo}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default CaseModalVideo;

CaseModalVideo.defaultProps = {
  posterImage: {},
  text: '',
  video: '',
  className: ""
};

CaseModalVideo.propTypes = {
  posterImage: PropTypes.object,
  text: PropTypes.string,
  className: PropTypes.string,
  video: PropTypes.any,
};
